import { render, staticRenderFns } from "./Private.vue?vue&type=template&id=1d8ede53&scoped=true&lang=html&"
import script from "./Private.vue?vue&type=script&lang=js&"
export * from "./Private.vue?vue&type=script&lang=js&"
import style0 from "./Private.vue?vue&type=style&index=0&id=1d8ede53&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d8ede53",
  null
  
)

export default component.exports